import Layout from 'containers/Layout'
import { connect } from 'react-redux'
import {
	mapDispatchToProps,
	mapStateToProps
} from './index.props'

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
